// @flow

import type { AlertSuppressionState } from "./types";

export const initialState: AlertSuppressionState = {
  requestsInProgress: 0,
  alertsSuppressedBy: [],
  alertsSuppression: [],
  alertsSuppressionOptions: [],
};

export default initialState;
